@if (vista; as v) {
  <section class="detalle" [class.ajustada]="pantallaAncha()">
    <!-- Resumen: estado y lo más consultado. La identidad (nombre, EUI,
         cliente) está en el encabezado. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Envío de stats" ocultarVacio>
          <app-dt-estado [tono]="v.envio.tono" [etiqueta]="v.envio.etiqueta" />
          @if (v.envio.detalle) {
            <span class="dt-muted fecha">{{ v.envio.detalle }}</span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Ocupación de canal" ocultarVacio>
          <app-dt-estado
            [tono]="v.ocupacion.tono"
            [etiqueta]="v.ocupacion.etiqueta"
          />
          @if (v.toa) {
            <span class="dt-muted fecha">{{ v.toa }}</span>
          }
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Ratio RX/TX (15 días)"
          [valor]="v.trafico?.ratio"
        >
          @if (v.trafico) {
            <span class="dt-muted fecha">uplinks por downlink</span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Errores TX (15 días)" ocultarVacio>
          @if (v.trafico; as t) {
            <span [class.con-errores]="t.conErrores">{{ t.erroresTx }}</span>
          } @else {
            <span class="dt-vacio">Sin información</span>
          }
        </app-dt-dato>
      </app-dt-datos>
    </app-dt-card>

    @if (v.avisos.length) {
      <div class="avisos">
        @for (a of v.avisos; track $index) {
          <div class="aviso" [class]="'aviso ' + a.tipo">
            <mat-icon>{{ a.tipo === 'alerta' ? 'error' : 'warning' }}</mat-icon>
            <span>{{ a.mensaje }}</span>
          </div>
        }
      </div>
    }

    <div class="grilla">
      <div class="columna">
        <app-dt-card titulo="Gateway" icono="podcasts">
          <app-dt-datos>
            <app-dt-dato etiqueta="Gateway EUI" [valor]="v.eui" mono copiable />
            <app-dt-dato
              etiqueta="Nombre en ChirpStack"
              [valor]="v.nombreChirpstack"
            />
            <app-dt-dato etiqueta="Descripción" [valor]="v.descripcion" />
            <app-dt-dato
              etiqueta="Fecha de creación"
              [valor]="v.fechaCreacion"
            />
            <app-dt-dato
              etiqueta="Creado en ChirpStack"
              [valor]="v.fechaChirpstack"
            />
            <app-dt-dato
              etiqueta="Intervalo de stats"
              [valor]="v.intervaloStats"
            />
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="Tráfico (15 días)" icono="cell_tower">
          <app-dt-datos>
            <app-dt-dato etiqueta="Uplinks (RX)" [valor]="v.trafico?.uplinks" />
            <app-dt-dato
              etiqueta="Downlinks (TX)"
              [valor]="v.trafico?.downlinks"
            />
          </app-dt-datos>
        </app-dt-card>
      </div>

      <!-- Mapa: llena el alto de la columna (altoMapa, ver detalle de
           tracker) -->
      <div class="mapa" #contenedorMapa>
        <app-map-card
          [height]="pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '360px'"
          [config]="mapCardConfig"
        ></app-map-card>
      </div>
    </div>
  </section>
}
